import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/components/assessment/coreBaselineOverrides";
import "@/components/aposEngine/engineRuleOverrides";
import "@/components/daily/companionQuickActionOverrides";
import "@/index.css";
import App from "@/App";

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    window.__adaptiveCompanionInstallPrompt = event;
    window.dispatchEvent(new CustomEvent("adaptive-companion-install-ready"));
  });
  window.addEventListener("appinstalled", () => {
    window.__adaptiveCompanionInstallPrompt = null;
    window.dispatchEvent(new CustomEvent("adaptive-companion-installed"));
  });
}

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {
      // The browser app remains fully usable when installation is unavailable.
    });
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
